import store from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Set the selectedFolderId in the inbox rules store
 * @param id the folder ID to set
 */
export default action('setSelectedFolderId')(function setSelectedFolderId(id) {
    store.inboxRulesEditState.selectedFolderId = id;
});
//# sourceMappingURL=setSelectedFolderId.js.map